import { render, staticRenderFns } from "./sectionMediumHomeTwo.vue?vue&type=template&id=1f556206&"
import script from "./sectionMediumHomeTwo.vue?vue&type=script&lang=js&"
export * from "./sectionMediumHomeTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sectionMediumHomeTwo.vue"
export default component.exports